// third-party
import { FormattedMessage } from 'react-intl';
import Groups2Icon from '@mui/icons-material/Groups2';

// assets
import WarehouseIcon from '@mui/icons-material/Warehouse';
import BugReportIcon from '@mui/icons-material/BugReport';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import { IconChartArcs, IconListCheck, IconUsers, IconClipboardList, IconChartInfographic, IconDashboard, IconHome2, IconCalendarTime } from '@tabler/icons';

// constant
const icons = {
    IconChartArcs: IconChartArcs,
    IconListCheck: IconListCheck,
    IconUsers: IconUsers,
    IconClipboardList: IconClipboardList,
    IconChartInfographic: IconChartInfographic,
    IconDashboard: IconDashboard,
    IconHome2: IconHome2,
    IconCalendarTime: IconCalendarTime
};
//-----------------------|| WIDGET MENU ITEMS ||-----------------------//

export const ONDC = {
    id: 'ONDC',
    title: <FormattedMessage id="ONDC" />,
    type: 'group',
    children: [
        // {
        //     id: 'products',
        //     title: <FormattedMessage id="products" />,
        //     type: 'item',
        //     url: '/ondc-products',
        //     icon: IconListCheck,
        //     breadcrumbs: false,
        // },
        {
            id: 'All Ondc sellers',
            title: <FormattedMessage id="All Ondc sellers" />,
            type: 'item',
            url: '/ondc/sellerlist',
            icon: IconUsers,
            breadcrumbs: false,
        },
        // {
        //     id: 'My Orders',
        //     title: <FormattedMessage id="My Orders" />,
        //     type: 'item',
        //     url: '/ondc-orders-list',
        //     icon: WarehouseIcon,
        //     breadcrumbs: false,
        // },
        // {
        //     id: 'Complains',
        //     title: <FormattedMessage id="Complain" />,
        //     type: 'item',
        //     url: '/ondc-complain',
        //     icon: BugReportIcon,
        //     breadcrumbs: false,
        // },
        // {
        //     id: 'Settlement',
        //     title: <FormattedMessage id="Settlement" />,
        //     type: 'item',
        //     url: '/ondc/my-settlement-dashboard',
        //     icon: AttachMoneyIcon,
        //     breadcrumbs: false,
        // },


    ]
}